import notify from "devextreme/ui/notify";
import {
  ApiCtx,
  createApi,
  createPipe,
  dispatchActions,
  errorHandler,
  fetcher,
  headersMdw,
  Next,
  requestMonitor,
} from "saga-query";

import { insiderService, service } from "@app/service";

import type { PipeCtx, LoaderCtx } from "saga-query";

import type { Action } from "@app/types";
export interface ThunkCtx<P = any, D = any> extends PipeCtx<P>, LoaderCtx<P> {
  actions: Action[];
  json: D | null;
}

export const thunks = createPipe<ThunkCtx>();
thunks.use(errorHandler);
thunks.use(function* (ctx, next) {
  ctx.json = null;
  yield* next();
});
thunks.use(dispatchActions);
thunks.use(thunks.routes());

const errMessageMiddleware = function* (ctx: ApiCtx, next: Next) {
  yield* next();
  const { ok, status, statusText } = yield ctx.response;
  if (ctx.bodyType === "text" && ctx.json.data.includes("NOMESSAGE")) {
    return;
  }
  if (!ok) {
    yield notify(
      {
        message: `${status} ${statusText}`,
        width: 400,
        position: {
          at: "top",
          my: "top",
          of: "#root",
          offset: "0 22",
        },
      },
      "error",
      5000
    );
  }
};

export const api = createApi();
api.use(requestMonitor());
api.use(api.routes());
api.use(errMessageMiddleware);
api.use(headersMdw);
api.use(fetcher({ baseUrl: service }));

/* 
15-oct-2023
when updating saga-query from 7.2`` ... latest (9.0.2) I got error:
`Uncaught TypeError: (0 , robodux_1.createLoaderTable) is not a function
at ./node_modules/saga-query/dist/slice.js...`

Gradually updating I found that the error starts from 9.0.0 version
I also set the headersMdw in my api, but the error persists
For now I will use the 8.0.0 version as it works.
*/

export const inApi = createApi();
inApi.use(requestMonitor());
inApi.use(inApi.routes());
inApi.use(errMessageMiddleware);
inApi.use(headersMdw);
inApi.use(fetcher({ baseUrl: insiderService }));

export const inThunks = createPipe<ThunkCtx>();
inThunks.use(errorHandler);
inThunks.use(function* (ctx, next) {
  ctx.json = null;
  yield* next();
});
inThunks.use(dispatchActions);
inThunks.use(inThunks.routes());
